import React from "react";
import Blog_54 from "../component/Blog_54";
function Blog_54_container() {
  return <Blog_54 />;
}

export default Blog_54_container;
